export default {
  path: 'provider',
  component: () =>
    import(
      /* webpackChunkName: "contract-management" */ '@/views/uspqrp/contract-management/Wrapper.vue'
    ),
  children: [
    {
      path: '/uspqrp/contract-search',
      name: 'searchContract',
      component: () =>
        import(
          /* webpackChunkName: "contract-management" */ '@/views/uspqrp/contract-management/Main.vue'
        ),
      meta: {
        authorization: {
          requiresAuth: true,
          permissions: ['menu.uspqrp.contractmanagement'],
        },
      },
    },
    {
      path: '/uspqrp/contract-management/:companyId',
      name: 'searchRequest',
      component: () =>
        import(
          /* webpackChunkName: "contract-management" */ '@/views/uspqrp/contract-management/SearchRequest.vue'
        ),
      meta: {
        authorization: {
          requiresAuth: true,
          permissions: ['menu.uspqrp.contractmanagement'],
        },
      },
    },
    {
      path:
        '/uspqrp/contract-management/:companyId/:requestServiceId/:contractId?/:requestCompensatoryId?',
      name: 'contractManagement',
      component: () =>
        import(
          /* webpackChunkName: "contract-management" */ '@/views/uspqrp/contract-management/ContractManagement.vue'
        ),
      meta: {
        authorization: {
          requiresAuth: true,
          permissions: ['menu.uspqrp.contractmanagement'],
        },
      },
    },
    {
      path:
        '/provider/visit-registry/:companyId/:requestServiceId/:contractId/:academicYearId/:month?/:disableNavigation?',
      name: 'visitRegistry',
      component: () =>
        import(
          /* webpackChunkName: "contract-management" */ '@/views/provider/visit-registry/Main.vue'
        ),
      meta: {
        authorization: {
          requiresAuth: true,
          permissions: ['menu.uspqrp.contractmanagement'],
        },
      },
    },
    {
      path:
        '/uspqrp/intervention-plan-management/:contractId/:isSubmitable/:planId?',
      name: 'interventionPlanManagement',
      component: () =>
        import(
          /* webpackChunkName: "contract-management" */ '@/views/uspqrp/contract-management/InterventionPlanManagement.vue'
        ),
      meta: {
        authorization: {
          requiresAuth: true,
          permissions: ['menu.uspqrp.contractmanagement'],
        },
      },
    },
    {
      path: '/uspqrp/amended-plan-history/:planId/:contractId',
      name: 'amendedPlanHistory',
      component: () =>
        import('@/views/uspqrp/contract-management/AmendedPlanHistory.vue'),
    },
    {
      path:
        '/uspqrp/achievement-summary/:contractId/:isSubmitable/:planId/:isAchievementSummary',
      name: 'achievementSummary',
      component: () =>
        import(
          /* webpackChunkName: "contract-management" */ '@/views/uspqrp/contract-management/InterventionPlanManagement.vue'
        ),
      meta: {
        authorization: {
          requiresAuth: true,
          permissions: ['menu.uspqrp.contractmanagement'],
        },
      },
    },
  ],
};
